import Image from "next/image";
import styles from "./ulcer-management-country.module.scss";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";

export default function UlcerManagementCountry() {
  return (
    <div className={`${styles["UlcerManagementCountry"]}`}>
      <div className={`${styles["UlcerManagementCountryContainer"]}`}>
        <div className={`${styles["UlcerManagementCountryMiddle"]}`}>
          <div className={`${styles["UlcerManagementCountryMiddleItem"]}`}>
            <Image
              src="/images/ulcer-management-country/logo-global-pharma.png"
              alt="globalpharma"
              width={270}
              height={40}
              className={`${styles["UlcerManagementCountryMiddleItemMainImage"]}`}
            />
            <a href="/en/globalpharma-emilok20/" rel="noopener">
              <ArrowCircleLeftOutlinedIcon />
            </a>
            <h1>Patient Information leaflet / نشرة معلومات المريض</h1>

            <a
              href="https://qrhub.io/accounts/globalpharma/emilok20/Emilok20-En-Ar-LFLT.pdf"
              target="_blank"
              rel="noopener"
              className={`${styles["UlcerManagementCountryMiddleItemPdfLink"]}`}
            >
              <Image
                src="/images/ulcer-management-country/pdf-icon.svg"
                alt="pdf"
                width={16}
                height={16}
              />
              UAE / الإمارات العربية المتحدة
            </a>
          </div>
        </div>
      </div>
      <div className={`${styles["UlcerManagementCountryBottom"]}`}>
        <p>
          POWERED BY{" "}
          <a href="https://www.qrhub.io" target="_blank" rel="noopener">
            <strong>QRHUB.IO</strong>{" "}
          </a>
          AND{" "}
          <a href="https://www.effective.ae" target="_blank" rel="noopener">
            <strong>EFFECTIVE AGENCY</strong>{" "}
          </a>
          COMPANY
        </p>
      </div>
    </div>
  );
}

UlcerManagementCountry.hideLayout = true;
